import { Box, Button, Dialog, Heading, Notice, Text } from '@applyboard/crystal-ui';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var SuspendedRPDialog = function SuspendedRPDialog(_ref) {
  var isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    onCloseClick = _ref.onCloseClick,
    title = _ref.title,
    noticeMessage = _ref.noticeMessage,
    instruction = _ref.instruction;
  return _jsxs(Dialog, {
    onOpenChange: setIsOpen,
    open: isOpen,
    children: [_jsx(Dialog.Heading, {
      children: _jsx(Heading, {
        intent: "secondary",
        contrast: "high",
        level: 2,
        variant: "titleM",
        children: title
      })
    }), _jsxs(Dialog.Content, {
      children: [_jsx(Notice, {
        intent: "negative",
        width: "fill",
        children: noticeMessage
      }), _jsx(Box, {
        py: 6,
        px: 0,
        children: _jsx(Text, {
          as: "p",
          intent: "secondary",
          contrast: "high",
          variant: "bodyM",
          children: instruction
        })
      })]
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        intent: "primary",
        onClick: function onClick() {
          onCloseClick(false);
        },
        width: "fill",
        type: "button",
        emphasis: "contained",
        children: "Close"
      })
    })]
  });
};